import currentDialog from '../shared/dialog-reducer';
import customize from '../shared/customize-reducer';
import feedback from '../shared/feedback-reducer';
import forcePublicView from '../shared/force-public-view-reducer';
import games from '../shared/games-reducer';
import highlights from '../shared/highlights-reducer';
import roster from './roster-reducer';
import team from '../shared/team-reducer';
import followers from '../shared/followers-reducer';
import schedule from './schedule-reducer';
import toast from '../shared/toast-reducer';
import user from '../shared/user-reducer';

const profileApp = {
  ads: state => state || {},
  bulkSaves: state => state || false,
  canDismissFeedItems: state => state || false,
  convertTimesToLocal: state => state || false,
  currentDialog,
  customize,
  deviceInfoForLogging: state => state || {},
  feedback,
  feedContentItems: state => state || [],
  followers,
  forcePublicView,
  hideRosterAndSchedule: state => state || false,
  highlights,
  highlightEditorIdentityData: state => state || {},
  httpsAllowed: state => state || false,
  games,
  isMobile: state => state || false,
  hasHighlightsDisabled: state => state || false,
  onboarding: state => state || {isDismissed: true},
  presetFilterType: state => state || 0,
  profileDateCreated: state => state || '',
  profileFuzzyDateCreated: state => state || '',
  recentlyConvertedTeam: state => state || false,
  recruiterAccess: state => state || null,
  recruitingSupportGuideUrl: state => state || null,
  roster,
  schedule,
  seoFriendlyName: state => state || 'team-name',
  subNavItems: state => state || [],
  team,
  toast,
  user,
  mediaSnowplowTrackerContext: state => state || null,
};

export default profileApp;
